import { render, staticRenderFns } from "./DbPageSimple.vue?vue&type=template&id=ee7386b6&scoped=true&"
import script from "./DbPageSimple.vue?vue&type=script&lang=ts&"
export * from "./DbPageSimple.vue?vue&type=script&lang=ts&"
import style0 from "./DbPageSimple.vue?vue&type=style&index=0&id=ee7386b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee7386b6",
  null
  
)

export default component.exports